export default __webpack_public_path__ + "static/media/signature-patricio.2e5c860c.jpg";